import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import EmployeeFormModal from '../../components/employees/EmployeeFormModal/index.jsx';
import {
  createEmployee,
  retrieveSimplifiedEmployees,
  selectRetrieveSimplifiedEmployeesState,
  updateEmployee,
} from '../../modules/employees.js';
import { selectCurrentOrganizationId } from '../../modules/auth.js';
import {
  retrieveOrgGroups,
  selectRetrieveGroupsState,
} from '../../modules/orgGroups.js';

const mapStateToProps = (state, ownProps) => {
  const retrieveSuccess = [
    selectRetrieveGroupsState,
    selectRetrieveSimplifiedEmployeesState,
  ].every((select) => select(state).success);

  return {
    organizationId: selectCurrentOrganizationId(state),
    retrieveSuccess: ownProps.employeeId ? retrieveSuccess : true,
  };
};

const mapDispatchToProps = {
  createEmployee,
  updateEmployee,
  retrieveSimplifiedEmployees,
  retrieveOrgGroups,
};

function EmployeeFormContainer(props) {
  const {
    employeeId,
    organizationId,
    showFormModal,
    onHideFormModal,
    updateEmployee,
    type,
    retrieveSuccess,
    retrieveSimplifiedEmployees,
    createEmployee,
    onSubmitSuccess,
    preselectedValues,
    isInitiative,
  } = props;

  const [entities, setEntities] = useState({
    employee: null,
    group: [],
    parent: [],
  });

  const updateEntities = (payload) => {
    setEntities((prevEntities) => ({
      ...prevEntities,
      ...payload,
    }));
  };

  const fetchAndUpdEntities = (id, key) => {
    retrieveSimplifiedEmployees({
      autocomplete: false,
      employeeIds: [id],
    }).then(({ entities, result }) => {
      const employeeEntity =
        entities.employeesAutocomplete[result.employees[0]];
      if (key === 'employee') {
        updateEntities({
          employee: employeeEntity,
          group: employeeEntity.group ? [employeeEntity.group] : [],
        });
      } else if (key === 'parent') {
        updateEntities({
          parent: employeeEntity ? [employeeEntity] : [],
        });
      }
    });
  };

  const onParentSelect = (employee) => {
    updateEntities({
      parent:
        entities.parent.length && entities.parent[0]?.id === employee.id
          ? []
          : [employee],
    });
  };

  const onGroupSelect = (group) => {
    updateEntities({
      group:
        entities.group.length && entities.group[0]?.id === group.id
          ? []
          : [group],
    });
  };

  useEffect(() => {
    if (showFormModal && employeeId) {
      fetchAndUpdEntities(employeeId, 'employee');
    }
  }, [employeeId, showFormModal]);

  useEffect(() => {
    if (entities.employee?.parentId) {
      fetchAndUpdEntities(entities.employee.parentId, 'parent');
    }
  }, [entities.employee]);

  useEffect(() => {
    if (preselectedValues) setEntities({ ...preselectedValues });
  }, [preselectedValues]);

  useEffect(() => {
    !showFormModal &&
      setEntities({
        employee: null,
        group: [],
        parent: [],
      });
  }, [showFormModal]);

  return (
    <EmployeeFormModal
      organizationId={organizationId}
      onSubmitSuccess={onSubmitSuccess}
      onHide={onHideFormModal}
      show={showFormModal}
      resource={entities.employee}
      isGroupSelectDisabled={false}
      onGroupSelect={onGroupSelect}
      onParentSelect={onParentSelect}
      createEmployee={createEmployee}
      updateEmployee={updateEmployee}
      retrieveEmployees={retrieveSimplifiedEmployees}
      selectedEntities={entities}
      isInitiative={isInitiative}
      retrieveSuccess={retrieveSuccess}
      type={type}
    />
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmployeeFormContainer);
